module.exports = __webpack_public_path__ + "static/denik-0ab70eef80548226ac00031eee011af2.png";